import { LRS_OBJECT_TYPES } from '@techchange/components';

const {
	DISCUSSION_COMMENT,
	DISCUSSION_THREAD,
	DISCUSSION_TOPIC,
	FORM,
	FORM_ENTRY,
	POLL,
	QUIZ,
} = LRS_OBJECT_TYPES;

/**
 * Gets the map of possible object options for specific object types.
 *
 * @param   {object} intl     Provider for internationalization.
 * @param   {object} objects  The set of object lists.
 *
 * @returns {object} result   The list of object select options mapped by object type.
 */
export default function getObjectOptionsMap(intl, objects) {

	const {
		discussionThreads,
		discussionTopics,
		forms,
		polls,
		quizzes,
		gravityForms, // DEPRECATED
	} = objects;

	const result = {};

	/**
	 * FORM ENTRY OBJECT OPTIONS
	 */
	const formEntryObjectOptions = [];

	// Form Resources
	if (forms) {

		for (const formResource of forms) {

			formEntryObjectOptions.push({
				label: formResource.title,
				value: formResource.data.form_id,
				resource_id: formResource.id,
				object_type: FORM_ENTRY,
				object_id: null,
				object_title: null,
				parent_object_type: FORM,
				parent_object_id: formResource.data.form_id,
				parent_object_title: formResource.title,
			});

		}

	}

	// Poll Resources
	if (polls) {

		for (const pollResource of polls) {

			formEntryObjectOptions.push({
				label: pollResource.title,
				value: pollResource.data.form_id,
				resource_id: pollResource.id,
				object_type: FORM_ENTRY,
				object_id: null,
				object_title: null,
				parent_object_type: POLL,
				parent_object_id: pollResource.data.form_id,
				parent_object_title: pollResource.title,
			});

		}

	}

	// Gravity Forms
	if (gravityForms) {

		for (const gravityForm of gravityForms) {

			if (gravityForm.tc_uuid) {

				formEntryObjectOptions.push({
					label: gravityForm.title,
					value: gravityForm.tc_uuid,
					object_type: FORM_ENTRY,
					object_id: null,
					object_title: null,
					parent_object_type: FORM,
					parent_object_id: gravityForm.tc_uuid,
					parent_object_title: gravityForm.title,
				});

			}

		}

	}

	if (formEntryObjectOptions.length > 0) {
		result[FORM_ENTRY] = formEntryObjectOptions;
	}

	/**
	 * QUIZ OBJECT OPTIONS
	 */

	// Quiz Resources
	if (quizzes && quizzes.length > 0) {

		const quizObjectOptions = [];

		for (const quizResource of quizzes) {

			quizObjectOptions.push({
				label: quizResource.title,
				value: quizResource.data.form_id,
				resource_id: quizResource.id,
				object_type: QUIZ,
				object_id: quizResource.data.form_id,
				object_title: quizResource.title,
				parent_object_type: null,
				parent_object_id: null,
				parent_object_title: null,
			});

		}

		result[QUIZ] = quizObjectOptions;

	}

	/**
	 * DISCUSSION COMMENT OBJECT OPTIONS
	 */
	if (discussionThreads && discussionThreads.length > 0) {

		const commentObjectOptions = [];

		// Build list of options for specific parent thread
		for (const thread of discussionThreads) {

			commentObjectOptions.push({
				label: thread.title,
				value: thread.id,
				object_type: DISCUSSION_COMMENT,
				object_id: null,
				object_title: null,
				parent_object_type: DISCUSSION_THREAD,
				parent_object_id: thread.id,
				parent_object_title: thread.title,
			});

		}

		result[DISCUSSION_COMMENT] = commentObjectOptions;

	}

	/**
	 * DISCUSSION THREAD OBJECT OPTIONS
	 */
	if (discussionTopics && discussionTopics.length > 0) {

		const threadObjectOptions = [];

		// Build list of options for specific parent topic
		for (const topic of discussionTopics) {

			threadObjectOptions.push({
				label: topic.title,
				value: topic.id,
				object_type: DISCUSSION_THREAD,
				object_id: null,
				object_title: null,
				parent_object_type: DISCUSSION_TOPIC,
				parent_object_id: topic.id,
				parent_object_title: topic.title,
			});

		}

		result[DISCUSSION_THREAD] = threadObjectOptions;

	}

	return result;

}
